import React from "react";

export default function SmallerTransparent(props) {
  return <div className="min-w-sm mx-auto">{props.children}</div>;
  
}
